module.exports = __webpack_public_path__ + "static/media/komponenty_motion-sensor.7096357b.svg";